import { FC, FormEvent, useState } from "react";
import { login } from "../repositories/PredsenseRepository";
import logo from "../img/logo-1.svg";
import { Button } from "../components/buttons/Button";
import { Alert } from "@mui/material";

export const Login: FC = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState("");

  const handleLogin = async (e: FormEvent) => {
    e.preventDefault();
    setError("");
    const formData = new FormData();
    formData.set("email", email);
    formData.set("password", password);
    login(email, password)
      .then(() => {
        window.location.href = "/machines";
      })
      .catch((e) =>
        setError(e.response ? "Incorrect credentials" : "An error occurred")
      );
  };

  return (
    <div className="login-container">
      <img className="logo" src={logo} alt="logo" />
      <form className="login-form" onSubmit={handleLogin}>
        <h2>Welcome Back</h2>
        <input
          type="email"
          placeholder="Enter Your Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Enter Your Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <Button
          label={"LOG IN"}
          onClick={handleLogin}
          size="m"
          buttonProps={{ type: "submit" }}
        />
        {!!error && (
          <Alert severity="error" className="mt-3">
            {error}
          </Alert>
        )}
      </form>
    </div>
  );
};
